import React, { FC } from 'react'
//@ts-ignore
import DisableableDropdownField from 'shared/FormFields/DisableableDropdownField'
//@ts-ignore
import { withLookups, LookupType } from 'shared'
import { AccSearchCurrenciesProps } from '../components.type'

const obtainCurrencies = (currencies = []) =>
  currencies.map((currency) => ({
    id: currency.CCY,
    title: currency.CCY,
  }))

const makeOptions = (choices: Array<{ id: any; title: any }>) =>
  choices.map((choice, index) => ({
    key: index.toString(),
    text: choice.title,
    value: choice.id,
  }))

const AccSearchCurrencies: FC<AccSearchCurrenciesProps> = ({ selector, currencies }) => {
  const choices = obtainCurrencies(currencies)

  if (choices === undefined || choices === null) {
    return null
  }

  const options = makeOptions(choices)

  return (
    <DisableableDropdownField
      name="currencies"
      options={options}
      disabilityCheckboxName="currenciesDisabled"
      dropdownsShareOfWidth={14}
      disabled={selector}
    />
  )
}

//@ts-ignore
export default withLookups({
  type: LookupType.Search,
  query: ['CCYS as currencies'],
})(AccSearchCurrencies)
